import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Translate from '../../../utils/Translate';
import Header from '../../commons/Header/Header';
import './PaymentMethodsPage.css';
import UpsertCreditCardsContainer from './UpsertCreditCards/UpsertCreditCardsContainer';
import UpsertBillingProfileContainer from './UpsertBillingProfile/UpsertBillingProfileContainer';
import Alert from '../../commons/Alert/Alert';
import * as Pages from '../../../utils/Pages';

const PaymentMethodsPage = withRouter(props => (
  <div className="eva-3-dashboard-aftersale PaymentMethodsPage  -eva-3-mb-xlg -eva-3-tc-gray-1 -eva-3-bc-gray-4">
    <Header
      name={Translate.message('Medios de pago')}
      page={Pages.PAYMENT_METHODS}
    />
    <div className="eva-3-container -eva-3-bc-gray-4 -p-0 -p-md-2 -pb-md-4 -pl-md-5 -pr-md-5 -pt-4 -pb-4">
      <div className="dashboard-aftersale-results-container eva-3-row -no-gutter">
        {
          props.isMerging &&
          <div className="col -sm-12 -lg-8 -eva-3-mb-lg">
            <Alert type="warning" title={Translate.message('Estamos uniendo tus cuentas')}>
              {Translate.message('Mientras se realiza el proceso, no podrás modificar los datos de tu perfil. Por favor, regresá más tarde.')}
            </Alert>
          </div>
        }
        <div className="col -sm-12 -lg-8 ">
          <UpsertCreditCardsContainer
            creditCards={props.creditCards}
            hasError={props.clustersErrors.creditCards}
            isMerging={props.isMerging}
          />
        </div>
        {
          props.isBillingProfileSectionAvailable && (
            <div className="col -sm-12 -lg-8 -mt-3">
              <UpsertBillingProfileContainer
                billingProfiles={props.billingProfiles}
                hasError={props.clustersErrors.billingProfiles}
                isMerging={props.isMerging}
              />
            </div>
          )
        }
      </div>
    </div>
  </div>
));

PaymentMethodsPage.defaultProps = {
  billingProfiles: undefined,
};

PaymentMethodsPage.propTypes = {
  creditCards: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  billingProfiles: PropTypes.arrayOf(PropTypes.shape()),
  isBillingProfileSectionAvailable: PropTypes.bool.isRequired,
  clustersErrors: PropTypes.shape().isRequired,
  isMerging: PropTypes.bool.isRequired,
};

export default PaymentMethodsPage;
